import Headline from '../../../components/Headline';
import { Fragment } from 'react';
import Form from './Form';
import Message from './Message';
import Verification from './Verification';
import { useCallback, useState } from 'react';

const ProductionPermissions = () => {
  const [isVerified, setIsVerified] = useState(false);
  const [prodAccess, setProdAccess] = useState(null);

  const handleVerificationResponse = useCallback(
    (status, response) => {
      setIsVerified(status);
      setProdAccess(response);
    },
    [isVerified]
  );

  return (
    <Fragment>
      <Headline message='Production environment' />

      {!isVerified ? (
        <Verification onCallBack={handleVerificationResponse} />
      ) : (
        <Fragment>
          <Message />

          <Form permissions={prodAccess} />
        </Fragment>
      )}
    </Fragment>
  );
};

export default ProductionPermissions;
